<div class="admin-ticket-page">
  <!-- Page Header -->
  <div class="admin-ticket-header">
    <div>
      

      <h2>Support Tickets</h2>

      <p class="admin-ticket-subtitle">
        Review, assign and manage support requests raised by users.
      </p>
    </div>

    <div class="admin-ticket-summary">
      <div class="summary-card">
        <span>Total</span>
        <strong>{{ totalRecords }}</strong>
      </div>

      <div class="summary-card summary-card--open">
        <span>Open</span>
        <strong>{{ getTicketCount("Open") }}</strong>
      </div>

      <div class="summary-card summary-card--progress">
        <span>In Progress</span>
        <strong>{{ getTicketCount("In Progress") }}</strong>
      </div>

      <div class="summary-card summary-card--resolved">
        <span>Resolved</span>
        <strong>{{ getTicketCount("Resolved") }}</strong>
      </div>
    </div>
  </div>

  <!-- Toolbar -->
  <div class="admin-ticket-toolbar">
    <div class="admin-ticket-count">
      <div class="admin-ticket-count__icon">
        <i class="fa-solid fa-ticket"></i>
      </div>

      <div>
        <strong>All Support Tickets</strong>

        <small>
          {{ filteredTickets.length }} records found
        </small>
      </div>
    </div>

    <div class="admin-ticket-filters">
      <div class="admin-ticket-search">
        <i class="fa-solid fa-magnifying-glass"></i>

        <input
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="onFilterChange()"
          placeholder="Search ticket, name or subject"
        />
      </div>

      <select
        [(ngModel)]="selectedStatus"
        (ngModelChange)="onFilterChange()"
      >
        <option value="All">
          All Status
        </option>

        <option value="Open">
          Open
        </option>

        <option value="In Progress">
          In Progress
        </option>

        <option value="Resolved">
          Resolved
        </option>

        <option value="Closed">
          Closed
        </option>

        <option value="Deleted">
          Deleted
        </option>
      </select>
    </div>
  </div>

  <!-- Ticket Table -->
  <div class="admin-ticket-table-card">

    <!--
      MINIMUM FIX:
      Keep existing horizontal scroll normally.
      Only while the 3-dot action menu is open,
      allow the menu to display outside the table wrapper.
    -->
    <div
      class="admin-ticket-table-scroll"
      [style.overflow]="openActionMenuId !== null ? 'visible' : null"
    >
      <table class="admin-ticket-table">
        <thead>
          <tr>
            <th class="sr-column">Sr. No.</th>
            <th>Ticket</th>
            <th>User</th>
            <th>Subject</th>
            <th>Department</th>
            <th>Raised On</th>
            <th>Assigned To</th>
            <th>Status</th>
            <th class="action-column">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="
              let ticket of paginatedTickets;
              let index = index;
              trackBy: trackByTicketId
            "
          >
            <td>
              {{ getSerialNumber(index) }}
            </td>

            <td>
              <!--
                MINIMUM FIX:
                Clicking Ticket # / ID uses the same existing
                openTicketDetails(ticket) flow as 3-dot -> View Details.
              -->
              <div
                class="ticket-number-cell"
                (click)="openTicketDetails(ticket)"
                style="cursor: pointer;"
                title="View ticket details"
              >
                <div class="ticket-number-with-message">
                  <strong>
                    {{ ticket.ticketNo }}
                  </strong>

                  <span
                    class="ticket-message-indicator ticket-message-indicator--blink"
                    *ngIf="ticket.hasUnreadMessage"
                    title="New ticket or patient reply"
                    aria-label="New ticket or patient reply"
                  >
                    <i class="fa-solid fa-message"></i>
                  </span>
                </div>

                <small>
                  ID: {{ ticket.ticketId }}
                </small>
              </div>
            </td>

            <td>
              <div class="ticket-user-cell">
                <div class="ticket-user-avatar">
                  {{ getInitials(ticket.name) }}
                </div>

                <div>
                  <strong>
                    {{ ticket.name }}
                  </strong>

                  <small>
                    {{ ticket.mobile }}
                  </small>
                </div>
              </div>
            </td>

            <td>
              <div class="ticket-subject-cell">
                <strong>
                  {{ ticket.subject }}
                </strong>

                <small>
                  {{ ticket.category }}

                  <span *ngIf="ticket.subCategory">
                    · {{ ticket.subCategory }}
                  </span>
                </small>
              </div>
            </td>

            <td>
              <span class="department-badge">
                {{ ticket.department }}
              </span>
            </td>

            <td>
              <div class="ticket-date-cell">
                <strong>
                  {{ ticket.createdOn | date: "dd MMM yyyy" }}
                </strong>

                <small>
                  {{ ticket.createdOn | date: "hh:mm a" }}
                </small>
              </div>
            </td>

            <td>
              <div class="assignee-cell">
                <span
                  class="assignee-avatar"
                  *ngIf="ticket.assignedTo"
                >
                  {{ getInitials(ticket.assignedTo) }}
                </span>

                <span
                  class="assignee-name"
                  [class.assignee-name--empty]="!ticket.assignedTo"
                >
                  {{ ticket.assignedTo || "Unassigned" }}
                </span>
              </div>
            </td>

            <td>
              <span
                class="ticket-status"
                [ngClass]="getStatusClass(ticket.status)"
              >
                <span class="ticket-status__dot"></span>

                {{ ticket.status }}
              </span>
            </td>

            <td class="ticket-action-cell">
              <!--
                Keep the action menu available for every status.
                Closed and Deleted tickets expose View Details only.
              -->
              <button
                type="button"
                class="ticket-menu-button"
                aria-label="Ticket actions"
                (click)="toggleActionMenu(ticket.ticketId, $event)"
              >
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>

              <div
                class="ticket-action-menu"
                *ngIf="openActionMenuId === ticket.ticketId"
                (click)="$event.stopPropagation()"
              >
                <button
                  type="button"
                  (click)="openTicketDetails(ticket)"
                >
                  <i class="fa-regular fa-eye"></i>
                  View Details
                </button>

                <button
                  *ngIf="
                    ticket.status !== 'Closed' &&
                    ticket.status !== 'Deleted'
                  "
                  type="button"
                  (click)="openAssignModal(ticket)"
                >
                  <i class="fa-solid fa-user-plus"></i>
                  Assign Ticket
                </button>

                <button
                  *ngIf="
                    ticket.status !== 'Closed' &&
                    ticket.status !== 'Deleted'
                  "
                  type="button"
                  (click)="openStatusModal(ticket)"
                >
                  <i class="fa-solid fa-rotate"></i>
                  Update Status
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="paginatedTickets.length === 0">
            <td colspan="9">
              <div class="admin-ticket-empty">
                <div class="admin-ticket-empty__icon">
                  <i class="fa-regular fa-folder-open"></i>
                </div>

                <h3>No tickets found</h3>

                <p>
                  No support tickets match the selected filters.
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div
      class="admin-ticket-pagination"
      *ngIf="filteredTickets.length > 0"
    >
      <div class="admin-ticket-page-size">
        <select
          [ngModel]="pageSize"
          (ngModelChange)="changePageSize($event)"
        >
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
        </select>

        <span>
          Showing {{ pageStart }} to {{ pageEnd }}
          of {{ filteredTickets.length }}
        </span>
      </div>

      <div class="admin-ticket-page-controls">
        <button
          type="button"
          [disabled]="currentPage === 1"
          (click)="goToPage(currentPage - 1)"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>

        <button
          type="button"
          *ngFor="let page of pageNumbers"
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>

        <button
          type="button"
          [disabled]="currentPage === totalPages"
          (click)="goToPage(currentPage + 1)"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Ticket Details Modal -->
<div
  class="admin-ticket-modal"
  *ngIf="selectedTicket && modalMode === 'view'"
>
  <div
    class="admin-ticket-backdrop"
    (click)="closeModal()"
  ></div>

  <section class="admin-ticket-modal__panel">
    <div class="admin-ticket-modal__header">
      <div class="admin-ticket-modal__title">
        <div class="admin-ticket-modal__icon">
          <i class="fa-solid fa-ticket"></i>
        </div>

        <div>
          <span>Support Ticket</span>
          <h2>{{ selectedTicket.ticketNo }}</h2>
        </div>
      </div>

      <button
        type="button"
        class="admin-ticket-modal__close"
        (click)="closeModal()"
      >
        ×
      </button>
    </div>

    <div class="admin-ticket-modal__body">
      <div class="ticket-view-summary">
        <div>
          <span>Subject</span>
          <h3>{{ selectedTicket.subject }}</h3>
        </div>

        <span
          class="ticket-status"
          [ngClass]="getStatusClass(selectedTicket.status)"
        >
          <span class="ticket-status__dot"></span>
          {{ selectedTicket.status }}
        </span>
      </div>

      <div class="ticket-details-grid">
        <div class="ticket-detail-item">
          <span>User Name</span>
          <strong>{{ selectedTicket.name }}</strong>
        </div>

        <div class="ticket-detail-item">
          <span>Email</span>
          <strong>{{ selectedTicket.email }}</strong>
        </div>

        <div class="ticket-detail-item">
          <span>Mobile</span>
          <strong>{{ selectedTicket.mobile }}</strong>
        </div>

        <div class="ticket-detail-item">
          <span>Department</span>
          <strong>{{ selectedTicket.department }}</strong>
        </div>

        <div class="ticket-detail-item">
          <span>Category</span>
          <strong>{{ selectedTicket.category }}</strong>
        </div>

        <div class="ticket-detail-item">
          <span>Subcategory</span>
          <strong>
            {{ selectedTicket.subCategory || "--" }}
          </strong>
        </div>

        <div class="ticket-detail-item">
          <span>Assigned To</span>
          <strong>
            {{ selectedTicket.assignedTo || "Unassigned" }}
          </strong>
        </div>

        <div class="ticket-detail-item">
          <span>Raised On</span>
          <strong>
            {{
              selectedTicket.createdOn
                | date: "dd MMM yyyy, hh:mm a"
            }}
          </strong>
        </div>
      </div>

      <div class="ticket-description-box">
        <span>Query / Description</span>

        <p>
          {{ selectedTicket.description }}
        </p>
      </div>

      <div
        *ngIf="selectedTicket.attachments.length > 0"
      >
        <div
          class="ticket-attachment-box"
          *ngFor="
            let attachment of selectedTicket.attachments;
            let attachmentIndex = index
          "
        >
          <div class="ticket-attachment-info">
            <div class="ticket-attachment-icon">
              <i class="fa-regular fa-file"></i>
            </div>

            <div>
              <span>
                Attachment {{ attachmentIndex + 1 }}
                <small *ngIf="attachment.isLatest">
                  · Latest
                </small>
              </span>

              <strong>
                {{ attachment.name }}
              </strong>
            </div>
          </div>

          <button
            type="button"
            [disabled]="isTicketAttachmentLoading"
            (click)="
              viewTicketAttachment(
                selectedTicket,
                attachment
              )
            "
          >
            <i
              class="fa-regular"
              [ngClass]="
                isTicketAttachmentLoading &&
                ticketAttachmentAction === 'view'
                  ? 'fa-clock'
                  : 'fa-eye'
              "
            ></i>

            {{
              isTicketAttachmentLoading &&
              ticketAttachmentAction === "view"
                ? "Opening..."
                : "View"
            }}
          </button>

          <button
            type="button"
            [disabled]="isTicketAttachmentLoading"
            (click)="
              downloadAttachment(
                selectedTicket,
                attachment
              )
            "
          >
            <i
              class="fa-solid"
              [ngClass]="
                isTicketAttachmentLoading &&
                ticketAttachmentAction === 'download'
                  ? 'fa-spinner fa-spin'
                  : 'fa-download'
              "
            ></i>

            {{
              isTicketAttachmentLoading &&
              ticketAttachmentAction === "download"
                ? "Downloading..."
                : "Download"
            }}
          </button>
        </div>
      </div>

      <div class="ticket-activity-section">
        <div class="ticket-activity-heading">
          <i class="fa-regular fa-comments"></i>
          Ticket Activity
        </div>

        <div
          class="ticket-activity-item"
          *ngFor="let activity of selectedTicket.activities"
        >
          <div class="ticket-activity-dot"></div>

          <div>
            <strong>{{ activity.createdBy }}</strong>

            <p *ngIf="activity.comment">
              {{ activity.comment }}
            </p>

            <div
              class="ticket-message-attachment"
              *ngIf="activity.attachmentPath"
            >
              <div class="ticket-message-attachment__info">
                <i class="fa-regular fa-file"></i>

                <span>
                  {{ activity.attachmentName || "Attachment" }}
                </span>
              </div>

              <button
                type="button"
                (click)="viewActivityAttachment(activity)"
              >
                <i class="fa-regular fa-eye"></i>
                View
              </button>
            </div>

            <small>
              {{
                activity.createdOn
                  | date: "dd MMM yyyy, hh:mm a"
              }}
            </small>
          </div>
        </div>

        <p
          class="ticket-activity-empty"
          *ngIf="selectedTicket.activities.length === 0"
        >
          No activity has been added yet.
        </p>
      </div>

      <div
        class="ticket-reply-box"
        *ngIf="
          selectedTicket.status !== 'Closed' &&
          selectedTicket.status !== 'Deleted'
        "
      >
        <div class="ticket-reply-heading">
          <i class="fa-regular fa-message"></i>
          Reply to Patient
        </div>

        <textarea
          name="adminReplyText"
          [(ngModel)]="adminReplyText"
          rows="4"
          maxlength="1000"
          placeholder="Write your answer for the patient"
        ></textarea>

        <div class="ticket-reply-upload">
          <input
            #adminReplyFileInput
            id="admin-reply-attachment"
            type="file"
            accept=".jpg,.jpeg,.png,.pdf"
            (change)="onAdminReplyFileSelected($event)"
          />

          <label for="admin-reply-attachment">
            <i class="fa-solid fa-paperclip"></i>
            {{
              adminReplyFile
                ? adminReplyFile.name
                : "Attach JPG, PNG or PDF"
            }}
          </label>

          <div
            class="ticket-reply-upload__actions"
            *ngIf="adminReplyFile"
          >
            <button
              type="button"
              class="secondary-button"
              (click)="previewAdminReplyFile()"
            >
              <i class="fa-regular fa-eye"></i>
              View
            </button>

            <button
              type="button"
              class="secondary-button"
              (click)="removeAdminReplyFile(); adminReplyFileInput.value = ''"
            >
              <i class="fa-solid fa-xmark"></i>
              Remove
            </button>
          </div>
        </div>

        <div class="ticket-reply-actions">
          <small>
            This reply will be visible in the same ticket conversation.
          </small>

          <button
            type="button"
            class="primary-button"
            [disabled]="
              (!adminReplyText.trim() && !adminReplyFile) ||
              isSendingReply
            "
            (click)="sendAdminReply()"
          >
            {{
              isUploadingReplyAttachment
                ? "Uploading..."
                : isSendingReply
                  ? "Sending..."
                  : "Send Reply"
            }}
          </button>
        </div>
      </div>

      <div
        class="ticket-closed-notice"
        *ngIf="selectedTicket.status === 'Closed'"
      >
        <i class="fa-solid fa-lock"></i>
        This ticket is closed. Replies, assignment and status changes are disabled.
      </div>

      <div
        class="ticket-closed-notice"
        *ngIf="selectedTicket.status === 'Deleted'"
      >
        <i class="fa-solid fa-trash"></i>
        This ticket was deleted by the user. It is retained for audit history, and all admin actions are disabled.
      </div>
    </div>

    <div class="admin-ticket-modal__footer">
      <button
        type="button"
        class="secondary-button"
        (click)="closeModal()"
      >
        Close
      </button>

      <button
        *ngIf="
          selectedTicket.status !== 'Closed' &&
          selectedTicket.status !== 'Deleted'
        "
        type="button"
        class="primary-button"
        (click)="openAssignModal(selectedTicket)"
      >
        Assign Ticket
      </button>
    </div>
  </section>
</div>

<!-- Assign Ticket Modal -->
<div
  class="admin-ticket-modal"
  *ngIf="selectedTicket && modalMode === 'assign'"
>
  <div
    class="admin-ticket-backdrop"
    (click)="closeModal()"
  ></div>

  <section class="admin-ticket-modal__panel admin-ticket-modal__panel--small">
    <div class="admin-ticket-modal__header">
      <div class="admin-ticket-modal__title">
        <div class="admin-ticket-modal__icon">
          <i class="fa-solid fa-user-plus"></i>
        </div>

        <div>
          <span>Assign Ticket</span>
          <h2>{{ selectedTicket.ticketNo }}</h2>
        </div>
      </div>

      <button
        type="button"
        class="admin-ticket-modal__close"
        (click)="closeModal()"
      >
        ×
      </button>
    </div>

    <form
      #assignForm="ngForm"
      class="admin-action-form"
      (ngSubmit)="assignTicket()"
    >
      <div class="admin-form-group">
        <label for="assigned-to">
          Assign To <span>*</span>
        </label>

        <select
          id="assigned-to"
          name="assignedTo"
          [(ngModel)]="selectedAssignee"
          required
        >
          <option value="" disabled>
            Select support user
          </option>

          <option
            *ngFor="let assignee of assigneeList"
            [value]="assignee"
          >
            {{ assignee }}
          </option>
        </select>
      </div>

      <div class="admin-form-group">
        <label for="assignment-description">
          Assignment Description
        </label>

        <textarea
          id="assignment-description"
          name="assignmentDescription"
          [(ngModel)]="assignmentDescription"
          rows="4"
          maxlength="500"
          placeholder="Add assignment instructions"
        ></textarea>
      </div>

      <div class="admin-ticket-modal__footer">
        <button
          type="button"
          class="secondary-button"
          (click)="closeModal()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="primary-button"
          [disabled]="assignForm.invalid || isAssigningTicket"
        >
          {{
            isAssigningTicket
              ? "Assigning..."
              : "Assign Ticket"
          }}
        </button>
      </div>
    </form>
  </section>
</div>

<!-- Update Status Modal -->
<div
  class="admin-ticket-modal"
  *ngIf="selectedTicket && modalMode === 'status'"
>
  <div
    class="admin-ticket-backdrop"
    (click)="closeModal()"
  ></div>

  <section class="admin-ticket-modal__panel admin-ticket-modal__panel--small">
    <div class="admin-ticket-modal__header">
      <div class="admin-ticket-modal__title">
        <div class="admin-ticket-modal__icon">
          <i class="fa-solid fa-rotate"></i>
        </div>

        <div>
          <span>Update Status</span>
          <h2>{{ selectedTicket.ticketNo }}</h2>
        </div>
      </div>

      <button
        type="button"
        class="admin-ticket-modal__close"
        (click)="closeModal()"
      >
        ×
      </button>
    </div>

    <form
      #statusForm="ngForm"
      class="admin-action-form"
      (ngSubmit)="updateTicketStatus()"
    >
      <div class="admin-form-group">
        <label for="ticket-status">
          Status <span>*</span>
        </label>

        <select
          id="ticket-status"
          name="status"
          [(ngModel)]="updatedStatus"
          required
        >
          <option value="" disabled>
            Select status
          </option>

          <option value="Open">
            Open
          </option>

          <option value="In Progress">
            In Progress
          </option>

          <option value="Resolved">
            Resolved
          </option>

          <option value="Closed">
            Closed
          </option>
        </select>
      </div>

      <div class="admin-form-group">
        <label for="status-comment">
          Comment
        </label>

        <textarea
          id="status-comment"
          name="statusComment"
          [(ngModel)]="statusComment"
          rows="4"
          maxlength="500"
          placeholder="Add a status update comment"
        ></textarea>
      </div>

      <div class="admin-ticket-modal__footer">
        <button
          type="button"
          class="secondary-button"
          (click)="closeModal()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="primary-button"
          [disabled]="
            statusForm.invalid ||
            isUpdatingStatus
          "
        >
          {{
            isUpdatingStatus
              ? "Updating..."
              : "Update Status"
          }}
        </button>
      </div>
    </form>
  </section>
</div>